import { useDeleteConversation } from "@noa/api-client";
import { useAppStore } from "@noa/client-store";

export function useDeleteConversationWithReset() {
  const { mutate, isPending } = useDeleteConversation();
  const resetStore = useAppStore((state) => state.resetStore);
  const sessionId = useAppStore((state) => state.sessionId);

  const deleteConversation = (targetSessionId: string, options?: { onSuccess?: () => void }) => {
    mutate(targetSessionId, {
      onSuccess: () => {
        if (sessionId === targetSessionId) {
          resetStore();
        }
        options?.onSuccess?.();
      },
    });
  };

  return { deleteConversation, isPending };
}
